// extracted by mini-css-extract-plugin
export var pageForm = "ContentfulBlockForm-module--pageForm--thxYq";